import {ApiClient} from '@hconnect/apiclient'
import {spawnErrorToast} from '@hm/fundamental'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import {DOWNTIME_ANALYTICS_WIDGET_NAMESPACE} from '../../consts'
import {StoppagesFailureTypesResponse, DowntimeDashboardQueryKey} from '../../types'

const QueryPrefix = DowntimeDashboardQueryKey.StoppagesFailureTypes

type Params = {
  plantId: string
  from: Date
  to: Date
  yearOffset?: number
}

export const useStoppagesFailureTypes = (
  params: Params,
  options?: Omit<UseQueryOptions<StoppagesFailureTypesResponse, AxiosError>, 'queryKey' | 'queryFn'>
) => {
  const {plantId, from, to, yearOffset = 5} = params
  const startDate = from.toISOString()
  const endDate = to.toISOString()
  const {t} = useTranslation(DOWNTIME_ANALYTICS_WIDGET_NAMESPACE)

  const query = useQuery<StoppagesFailureTypesResponse, AxiosError>({
    queryKey: [QueryPrefix, plantId, startDate, endDate, yearOffset],
    queryFn: async ({signal}) => {
      const path = `/downtime-dashboard/${plantId}/stoppages/failure-types`
      const response = await ApiClient.axiosInstance.post<StoppagesFailureTypesResponse>(
        path,
        {
          timeRange: {
            startDate,
            endDate
          },
          yearOffset
        },
        {signal}
      )

      return response.data
    },
    ...options
  })

  useEffect(() => {
    if (query.error) {
      spawnErrorToast(t('message.failedToFetchStoppagesFailureTypes'), {closeOnClick: true})
    }
  }, [query.error, t])

  return query
}
